import React from 'react';
import { motion } from 'framer-motion';
export function ProductContentsSection() {
  const contents = [{
    tomo: '01',
    title: 'El Escudo de WhatsApp',
    desc: 'Protocolo anti-secuestro y anti-hackeo para tu cuenta.'
  }, {
    tomo: '02',
    title: 'Home Banking Inexpugnable',
    desc: 'Las configuraciones ocultas que el banco nunca te activó.'
  }, {
    tomo: '03',
    title: 'Billeteras Virtuales Blindadas',
    desc: 'Mercado Pago, Ualá y todas las demás — blindadas al máximo.'
  }, {
    tomo: '04',
    title: 'Ingeniería Social',
    desc: 'Cómo piensan los estafadores y cómo neutralizarlos.'
  }, {
    tomo: '05',
    title: 'Protocolo de Crisis',
    desc: 'Qué hacer en los primeros 60 minutos si te hackean.'
  }, {
    tomo: '06',
    title: 'Defensa Legal',
    desc: 'Tus derechos, cómo reclamar y cuánto podés recuperar.'
  }];
  return <section className="w-full py-16 px-4 sm:px-6 lg:px-8 flex flex-col items-center" data-id="element-299">
      <div className="max-w-3xl mx-auto w-full" data-id="element-300">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-301">
          <div className="text-brand-cyan text-[10px] font-bold tracking-[0.3em] uppercase mb-3" data-id="element-302">
            CONTENIDO PRINCIPAL
          </div>
          <h2 className="text-xl sm:text-2xl md:text-3xl font-extrabold text-white tracking-tight" data-id="element-303">
            Los <span className="text-brand-cyan" data-id="element-304">6 Tomos</span> del MegaPack
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-305">
          {contents.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="flex flex-col gap-1.5 p-4 rounded-lg border border-brand-cyan/15 hover:border-brand-cyan/50 hover:shadow-[0_0_30px_rgba(0,212,255,0.15),0_0_60px_rgba(0,212,255,0.05)] transition-all duration-300 cursor-pointer group" style={{
          background: 'linear-gradient(135deg, #0d1333 0%, #0a0f2e 100%)'
        }} data-id="element-306">
              <div className="flex items-center gap-3" data-id="element-307">
                <span className="inline-flex items-center justify-center w-7 h-7 rounded-md text-[10px] font-extrabold text-black shrink-0 group-hover:shadow-[0_0_12px_rgba(0,212,255,0.5)] transition-shadow duration-300" style={{
              background: 'linear-gradient(135deg, #67e8f9 0%, #00D4FF 50%, #0891b2 100%)'
            }} data-id="element-308">
                  {item.tomo}
                </span>
                <h3 className="text-sm font-bold text-white leading-tight" data-id="element-309">
                  {item.title}
                </h3>
              </div>
              <p className="text-gray-500 text-xs leading-relaxed" data-id="element-310">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}